import React, {useState} from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import assetify from "@quintype/framework/assetify";
import groupImage from "../../../../assets/images/newsletter.png";
import { TextField } from "../../atoms/textfield";
import { Button } from "../../atoms/button";
import { subscribeToMailchimp } from "../../pages/newsletter/api";
import { isValidEmail } from "../../../utils";
import "./subscribe-to-newsletters.m.css";
import LoadingIcon from "../../../../assets/images/loader.svg";

const defaultSummary = "We deliver weekly newsletters. Customised and curated for you. Check it out.";
const defaulttitle = "No spam! Newslaundry newsletters, tailored to your interests.";


export const SubscribeToNewsletters = ({ collection = {} }) => {

  const [showLoader, setShowLoader] = useState();
  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const [subscribeMailStatus, setSubscribeMailStatus] = useState([]);

  const onChange = e => {
    setEmail(e.target.value);
    e.target.value ? setError("") : setError("Please provide Email !!");
  };

  const onSubmitClick = () =>{
    if (email) {
      if (!isValidEmail(email)) {
        setError("Invalid Email !!");
      } else {
        setShowLoader(true);
        subscribeToMailchimp({
          email: email,
          listId5: "aa2c780e6c"
        })
          .then(status => {
           setSubscribeMailStatus(status);
           setEmail("");
           
           setShowLoader(false);
           setTimeout(function() {
            setSubscribeMailStatus([]);
            setCheckedItems([]);
          }, 6000);
          })
          .catch((err) => {
            console.log(err)
          });
      } 
    } else {
      setError("Please provide Email !!");
     
    }
  }

  const domainSlug = global.location && global.location.host.includes("hindi")?true:false
  return (
    <div styleName="row-container">
      <div styleName="subscribe-wrapper" className="full-width-with-padding">
        <div styleName="group-img">
          <img styleName="newsletter-image" src={assetify(groupImage)} alt="newlaundry logo" />
        </div>
        <div styleName="content-wrapper">
          <div styleName="collection-title">{collection.name || defaulttitle}</div>
          <div styleName="collection-summary">{collection.summary || defaultSummary}</div>
          <div styleName="btn-input">
          {domainSlug? <div styleName="subscribe-view-content ">
          {showLoader === true && (
            <div styleName="modal">
              <div styleName="modal-content">
                <img src={assetify(LoadingIcon)} alt="loading" />
              </div>
            </div>
          )}
            <TextField value={email} error={error} onChange={onChange} placeholder="Type your email" />

            <button styleName="submit-btn" onClick={onSubmitClick}>
            साइन अप 
            </button>
            
            </div>
            :
            <div styleName="subscribe-button">
            <Button href={"/newsletter-signup?ref=home"}>Sign Up</Button>
            </div>
          }
          </div>
          {subscribeMailStatus && subscribeMailStatus.length > 0 && (
            <div styleName="modal">
              <div styleName="modal-content show-message">Thanks for signing up. See you in your inbox soon.</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};


SubscribeToNewsletters.propTypes = {
  collection: PropTypes.object
};
